import React from "react";

function SettingsSection({ section }) {
  const SectionForm = section.Form;

  return (
    <div className="card shadow mb-3">
      <div className="card-header d-flex align-items-center">
        <button
          type="button"
          className="btn btn-link text-decoration-none text-dark p-0 d-flex align-items-center"
          onClick={section.toggle}
          aria-expanded={section.open}
          aria-controls={section.id}
        >
          <i
            className={`bi ${
              section.open ? "bi-chevron-down" : "bi-chevron-right"
            } me-2`}
          ></i>
          <strong>{section.title}</strong>
        </button>
        {section.badge && (
          <span className="badge bg-secondary ms-auto">{section.badge}</span>
        )}
      </div>
      {section.open && (
        <div className="card-body" id={section.id}>
          {section.description && (
            <p className="text-muted mb-3">{section.description}</p>
          )}
          <SectionForm {...section.formProps} />
        </div>
      )}
    </div>
  );
}

export default SettingsSection;
